import BurgerMenu from "../../../reusableUi/BurgerMenu";
import PrimaryButton from "../../../reusableUi/PrimaryButton";
import HeroImage from "../pictures/home-hero-plumber.webp";
import { Link } from "react-router-dom";
import { Phone, ChevronDown, Shield, Clock, Star, Mail, Pipette, Wrench, Droplet } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import StickyNav from "../../../reusableUi/DropDownBar";

const NAV_SERVICES = [
  ["/services/emergency-plumbing", "Emergency Plumbing"],
  ["/services/shower-head-repair", "Shower Head Repair"],
  ["/services/water-heater-services", "Water Heater Services"],
  ["/services/leak-detection-repair", "Leak Detection & Repair"],
  ["/services/toilet-fixture-repair", "Toilet & Fixture Repair"],
];

const NAV_LOCATIONS = [
  ["/locations/lincoln-park", "Lincoln Park"],
  ["/locations/wicker-park", "Wicker Park"],
  ["/locations/lakeview", "Lakeview"],
  ["/locations/hyde-park", "Hyde Park"],
  ["/locations/logan-square", "Logan Square"],
  ["/locations/river-north", "River North"],
  ["/locations/south-loop", "South Loop"],
  ["/locations/old-town", "Old Town"],
];

const TRUST_BADGES = [
  { icon: <Clock className="w-4 h-4" />, label: "24 / 7 Response" },
  { icon: <Shield className="w-4 h-4" />, label: "Licensed & Insured" },
  { icon: <Star className="w-4 h-4" />, label: "4.9★ Rated" },
];

function DropdownPanel({ items, linkTo, linkLabel }) {
  return (
    <div className="absolute top-full left-1/2 -translate-x-1/2 mt-3 w-72 bg-white rounded-2xl shadow-2xl border border-gray-100 p-5 z-50 navbar-popups">
      <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5 mb-5">
        {items.map(([to, label]) => (
          <li key={to}>
            <Link to={to} className="text-gray-600 text-sm font-medium hover:text-blue-600 transition-colors block leading-snug">
              {label}
            </Link>
          </li>
        ))}
      </ul>
      <Link to={linkTo} className="w-full block text-center text-sm font-semibold text-white bg-blue-600 hover:bg-blue-700 transition-colors px-4 py-2.5 rounded-xl">
        {linkLabel} &rarr;
      </Link>
    </div>
  );
}

function NavDropdownTrigger({ label, open, onClick }) {
  return (
    <button onClick={onClick} className="flex items-center gap-1 font-semibold text-white/80 hover:text-white transition-colors cursor-pointer text-sm navbar-links">
      {label}
      <ChevronDown className="w-4 h-4 transition-transform duration-200" style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }} />
    </button>
  );
}

export default function Hero() {
 
  const upSection = useRef(null);


  return (
    <>
      {/* ── Background glow ── */}
      <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-10 overflow-hidden">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[500px] rounded-full opacity-[0.07]"
          style={{ background: "radial-gradient(ellipse, #2563eb 0%, transparent 70%)" }} />
      </div>

      <header id="header">
        <div className="max-w-[90%] mx-auto xl:max-w-6xl">

          {/* ── Mobile static nav ── */}
          <nav className="md:hidden flex items-center justify-between py-5 mb-4">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
                <Wrench className="w-4 h-4 text-white" />
              </span>
              <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
            </Link>
            <BurgerMenu />
          </nav>

          {/* ── Tablet static nav ── */}
          <nav className="hidden md:flex lg:hidden items-center justify-between py-5 mb-6">
            <Link to="/" className="flex items-center gap-2.5">
              <span className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center shadow-md shadow-blue-600/30">
                <Wrench className="w-4 h-4 text-white" />
              </span>
              <span className="text-xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
            </Link>
            <ul className="flex items-center gap-8">
              <li><a href="#services" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">Services</a></li>
              <li><a href="#service-areas" className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">Service Areas</a></li>
              <li>
                <a href="#footer" className="text-sm font-bold bg-blue-600 hover:bg-blue-700 transition-colors px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25">
                  Contact Us
                </a>
              </li>
            </ul>
          </nav>

          {/* ── Desktop static nav ── */}
          <nav className="hidden lg:flex items-center justify-between py-6 mb-6">
            <Link to="/" className="flex items-center gap-3">
              <span className="w-9 h-9 bg-blue-600 rounded-xl flex items-center justify-center shadow-lg shadow-blue-600/30">
                <Wrench className="w-4 h-4 text-white" />
              </span>
              <span className="text-2xl font-black text-gray-900 tracking-tight">Chicago Plumbing</span>
            </Link>
            <ul className="flex items-center gap-10">
              {[["#services","Services"],["#service-areas","Service Areas"],["#reviews","Reviews"],["#faqs","FAQs"]].map(([href, label]) => (
                <li key={href}>
                  <a href={href} className="font-semibold text-gray-500 hover:text-gray-900 transition-colors text-sm">{label}</a>
                </li>
              ))}
              <li>
                <a href="tel:(312) 555-0147" className="flex items-center gap-2 font-bold bg-blue-600 hover:bg-blue-700 transition-all px-5 py-2.5 text-white rounded-xl shadow-md shadow-blue-600/25 text-sm">
                  <Phone className="w-4 h-4" /> (312) 555-0147
                </a>
              </li>
            </ul>
          </nav>
        </div>

<StickyNav upSectionRef={upSection} />
    
        {/* ══════════════════════════════════
             CENTERED HERO
        ══════════════════════════════════ */}
        <div id="hero-upper" ref={upSection} className="pb-28">

          {/* ── Centered text block ── */}
          <div className="flex flex-col items-center text-center max-w-3xl mx-auto space-y-6 mb-14">

            {/* Eyebrow */}
            <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
              Available Right Now — 24 / 7
            </div>

            {/* Headline */}
            <h1 className="font-black text-gray-900 text-5xl sm:text-6xl lg:text-7xl leading-[1.02] tracking-tight">
              Need a Plumber in Chicago?<br />
              <span className="text-blue-600">Call Us Now</span>
            </h1>

            {/* Subheading */}
            <p className="text-gray-500 text-lg lg:text-xl leading-relaxed md:max-w-xl max-w-md">
              Burst pipe? Clogged drain? We fix it fast — call now for immediate service.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-1">
              <a
                href="#footer"
                className="flex items-center gap-2 text-sm font-semibold text-gray-600 hover:text-blue-600 transition-colors px-4 py-3 rounded-xl border border-gray-200 hover:border-blue-200 bg-white hover:bg-blue-50"
              >
                <Mail className="w-4 h-4" /> Contact Us
              </a>
              <PrimaryButton />
            </div>

            {/* Trust badges */}
            <div className="flex flex-wrap items-center justify-center gap-2.5 pt-1">
              {TRUST_BADGES.map(({ icon, label }) => (
                <div key={label} className="flex items-center gap-1.5 text-xs font-semibold text-gray-500 bg-gray-50 border border-gray-200 px-3 py-1.5 rounded-lg">
                  {icon}
                  {label}
                </div>
              ))}
            </div>
          </div>

          {/* ── Full-width hero image ── */}
          <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-0">
            {/* Decorative offset frame */}
            <div aria-hidden="true" className="absolute inset-0 rounded-3xl border-2 border-blue-100 translate-x-3 translate-y-3 -z-10" />

            <img
              src={HeroImage}
              className="w-full rounded-3xl shadow-2xl object-cover max-h-[520px]"
              alt="A plumber fixing a kitchen faucet."
            />

            {/* Floating call card — bottom left */}
            <div className="absolute hidden md:flex bottom-6 left-8 bg-white rounded-2xl shadow-xl px-4 py-3 flex items-center gap-3 border border-gray-100">
              <div className="w-10 h-10 bg-blue-600 rounded-xl flex items-center justify-center flex-shrink-0 shadow-md shadow-blue-600/30">
                <Phone className="w-5 h-5 text-white" />
              </div>
              <div>
                <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Call anytime</p>
                <p className="text-sm font-black text-gray-900 tracking-tight">(312) 555-0147</p>
              </div>
            </div>

            {/* Floating rating card — bottom right */}
            <div className="absolute bottom-6 right-8 bg-white rounded-2xl shadow-xl px-4 py-3 border border-gray-100">
              <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1">Customer Rating</p>
              <div className="flex items-center gap-1.5">
                <span className="text-xl font-black text-gray-900">4.9</span>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-3.5 h-3.5 text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
              </div>
              <p className="text-[10px] text-gray-400 mt-0.5">Based on 800+ reviews</p>
            </div>
          </div>
        </div>
      </header>
    </>
  );
}